import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button,} from 'primereact';
import { Container, Row, Col, Card, Modal } from 'react-bootstrap';
const TokenExpiredPageComponent = () => {

  const navigate = useNavigate();

  const handleOk = () => {
    navigate('/');  // Go back to the homepage
  };
  return (
    <div className="errorContainer">
    <div className="errorBox">
    <h2 >Your token has expired</h2>
    <p>Please start the search again.</p>
    <Button variant="secondary" onClick={handleOk}>
            OK
          </Button>       
    </div>
</div>
  
  );
};



export default TokenExpiredPageComponent;
